import React from "react";
import styled from "styled-components";

const ToggleSwitchButton = ({checked, name, onChange}) => {

    return (
        <Switch>
            <input
                type="checkbox"
                className="toggle-switch-checkbox"
                name={name}
                id={name}
                checked={checked}
                onChange={e => onChange(e.target.checked, name)}
            />
            <label className="toggle-switch-label" htmlFor={name}>
                <span className="toggle-switch-inner" data-yes="Oui" data-no="Non"/>
                <span className="toggle-switch-switch"/>
            </label>
        </Switch>
    )
}


const Switch = styled.label`
  position: relative;
  width: 4rem;
  display: inline-block;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  text-align: left;

  .toggle-switch-checkbox {
    display: none;
  }

  .toggle-switch-label {
    display: block;
    overflow: hidden;
    cursor: pointer;
    border: 0 solid #bbb;
    border-radius: 20px;
    margin: 0;
  }

  .toggle-switch-inner {
    display: block;
    width: 200%;
    margin-left: -100%;
    transition: margin 0.3s ease-in 0s;
  }

  .toggle-switch-inner:before, .toggle-switch-inner:after {
    display: block;
    float: left;
    width: 50%;
    height: 1.5rem;
    padding: 0;
    font-size: 14px;
    color: white;
    box-sizing: border-box;
  }

  .toggle-switch-inner:before {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    content: attr(data-yes);
    padding-left: 10px;
    background-color: var(--color-green);
    color: var(--color-white);

  }


  .toggle-switch-inner:after {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    content: attr(data-no);
    padding-right: 8px;
    background-color: var(--color-grey);
    color: var(--color-white);
    text-align: right;
  }

  .toggle-switch-switch {
    display: block;
    width: 24px;
    margin: 0;
    background: #fff;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 40px;
    border: 0 solid #bbb;
    border-radius: 20px;
    transition: all 0.3s ease-in 0s;
  }

  .toggle-switch-checkbox:checked + .toggle-switch-label .toggle-switch-inner {
    margin-left: 0;
  }

  .toggle-switch-checkbox:checked + .toggle-switch-label .toggle-switch-switch {
    right: 0;
  }

`

export default ToggleSwitchButton;